import { PropsWithChildren } from "react";
import { Link } from "@ludens-reklame/rubics-v3-sdk/link/types";
import { getLinkProps } from "../../client-utils/getLinkProps.js";

export type ButtonVariant = "primary" | "secondary";

export type ButtonSize = "default" | "large";

interface CommonProps {
  link?: Link;
  variant?: ButtonVariant;
  size?: ButtonSize;
}

type ButtonProps = CommonProps & React.ButtonHTMLAttributes<HTMLButtonElement>;
type AnchorProps = CommonProps & React.AnchorHTMLAttributes<HTMLAnchorElement>;
type Props = ButtonProps | AnchorProps;

export const Button: React.FC<PropsWithChildren<Props>> = ({
  link,
  variant = "primary",
  size = "default",
  children,
  ...rest
}) => {
  const variantClassName = `button-${variant}`;
  const sizeClassName = `button-${size}`;

  if (link) {
    const linkProps = getLinkProps(link);

    return (
      <a
        className={`button ${variantClassName} ${sizeClassName}`}
        {...linkProps}
        {...(rest as AnchorProps)}
      >
        {link.title || children}
      </a>
    );
  }

  return (
    <button
      className={`button ${variantClassName} ${sizeClassName}`}
      {...(rest as ButtonProps)}
    >
      {children}
    </button>
  );
};
